import http from '@root/utils/axios/admin';

let state = {
    GameActivitiesList: [],
    EventsList: [],
    GameActivity: {
        data: {},
        error: {}
    },
    Event: {
        data: {},
        error: {}
    },
}

let actions = {

    fetchGameActivitiesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-activities', { params: filter }).then((response) => {
                commit('setGameActivitiesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGameActivity({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-activities/' + id).then((response) => {
                commit('setGameActivity', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchEventsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/events', { params: filter }).then((response) => {
                commit('setEventsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchEvent({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/events/' + id).then((response) => {
                commit('setEvent', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


}


let mutations = {
    setGameActivitiesList(state, data) {
        state.GameActivitiesList = data;
    },
    setGameActivity(state, data) {
        state.GameActivity.data = data;
    },
    setEvent(state, data) {
        state.Event.data = data;
    },
    setEventsList(state, data) {
        state.EventsList = data;
    },
}

export default {
    state,
    actions,
    mutations
}